import React from 'react';
import { CalendarIcon, MessageCircleIcon } from 'lucide-react';
import { useStore } from '../contexts/StoreContext';
import { salon } from '../data/content';
export function MobileActionBar() {
  const {
    openBooking
  } = useStore();
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-shell/95 px-4 py-3 backdrop-blur-md lg:hidden" data-id="element-213" data-mp="ev4cx6cwsaz6">
      <div className="flex gap-2" data-id="element-214" data-mp="jr1svbk9ffbf">
        <button type="button" onClick={() => openBooking()} className="flex flex-1 items-center justify-center gap-2 rounded-full bg-ink py-3 text-[13px] text-shell" data-id="element-215" data-mp="3j9cabi444bxl">
          <CalendarIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-216" data-mp="3s86ebtjrw4l6" />
          Boek een afspraak
        </button>
        <a href={salon.whatsapp} aria-label="Advies via WhatsApp" className="flex items-center justify-center rounded-full border border-line px-5 text-ink" data-id="element-217" data-mp="vlej59wge02">
          <MessageCircleIcon className="h-4 w-4" strokeWidth={1.5} data-id="element-218" data-mp="34ilkugpztoxn" />
        </a>
      </div>
    </div>;
}